import types from '../../types';

const currencies = (state = { loading: true, data: null }, { type, payload }) => {
  switch (type) {
    case types.GET_CURRENCIES_START:
      return { ...state, loading: true };

    case types.GET_CURRENCIES_SUCCESS:
      return { data: payload, loading: false };

    case types.GET_CURRENCIES_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default currencies;
